import { Component, OnInit, Input, Output, HostListener, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ErrorService } from '../../error/error.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BuywifiService } from '../../../services/buywifi.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppService } from '../../../app.service';
import { HttpService } from '../../../services/http.service';
import { BreadcrumbsService } from '../../breadcrumbs/breadcrumbs.service';
import { AccessibilityService } from '../../../services/accessibility.service';
import { CartService } from './cart.service';
import { APP_TRANSLATE } from '../../../app.translation.en';
import { PaymentSelectionComponent } from '../../eb/paymentSelection.component';
import { ONBOARD_CONSTANTS } from 'src/app/app.constants';
import { LandingComponent } from '../../landing/landing.component';


@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartComponent implements OnInit {
  loaderTextList = { loaderHeaderText: APP_TRANSLATE.loaderText, loaderSubHeaderText: '' };
  @Input() public sessionValue: number;
  @Input() public price: number;
  @Input() public selectedCurrency: string;
  @Output() cartButtonEvent: EventEmitter<any> = new EventEmitter();
  public passengerInfo: any;
  public currentSegment: any;
  public origin: any;
  public destination: any;
  public flightNumber: any;
  public flightResponseData: any;
  public cartButton = new EventEmitter<boolean>();
  emailForm: FormGroup;
  eRgex: RegExp;
  showEmailErrorMsg = false;
  emailTopSet = false;
  isEmailPresent = false;
  updateEmailOverLay = false;
  showCart = true;
  mapOverlay = false;
  updateEmailRequest;
  vehicleIdNumber;
  showLongRangeMap = false;
  fullFillment = this.appService.ancFullFillment;
  isUnconfirmedTicket: any;
  static showPaymentConfirmationScreen = false;
  public showEBforPointsBuy = PaymentSelectionComponent.showEBforPointsBuy;

  constructor(private router: Router,
    private fb: FormBuilder,
    private appService: AppService,
    private httpService: HttpService,
    private translate: TranslateService,
    private accessibilityService: AccessibilityService,
    private errorService: ErrorService,
    private breadcrumbsService: BreadcrumbsService,
    public buyWifiService: BuywifiService,
    private cartService: CartService) { }

  ngOnInit() {
    this.checkLongRangeFlight();
    this.vehicleIdNumber = this.appService.getFlightResponse().vehicleId;
   
    this.eRgex = /^[_a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[_a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,6})$/;
    this.emailForm = this.fb.group({
      'email': ['', [Validators.required,
      Validators.pattern(this.eRgex)]]
    });
    this.passengerInfo = this.buyWifiService.getPassengerResponse();
    if (!this.showEBforPointsBuy) {
      this.currentSegment = this.buyWifiService.getCurrentSegment();
      this.buyWifiService.checkReleaseCall();
    }
    else {
      this.origin = this.buyWifiService.getOriginFromFlightResponse();
      this.destination = this.buyWifiService.getDestinationFromFlightResponse();
      this.flightNumber = this.appService.getFlightResponse().flightNumber;
    }
  }

  checkLongRangeFlight(){
    this.flightResponseData = this.appService.getFlightResponse();
    this.showLongRangeMap = (this.flightResponseData && this.flightResponseData.longRange) ? this.flightResponseData.longRange: false;
   
  }



  emailFormSubmit() {
    if (this.emailForm.valid) {
      const loaderTextList = { loaderHeaderText: APP_TRANSLATE.loaderText, loaderSubHeaderText: '' };
      this.appService.showLoaderWithText(loaderTextList);
      this.buyWifiService.receiptEmailAddress = this.email.value;
      this.cartService.doUpdateEmailCall(this.email.value, this.passengerInfo.reservationInfo.reservationPassengerId).subscribe(
        updateEmailResponse => {
          if (updateEmailResponse.status === 'SUCCESS') {
            this.cartService.updatedEmailInPaxResponse(this.email.value);
            this.callInitiateBasedOnCondition(this.email.value, loaderTextList);
          } else if (updateEmailResponse.status === 'FAILURE') {
            this.appService.hideLoaderWithText();
            const singleError = [];
            singleError.push(updateEmailResponse.error);
            this.errorService.addError(singleError);
          }
        }, (error) => {
          this.appService.hideLoaderWithText();
          this.errorService.addError(error);
        }
      );
    } else {
      this.showEmailErrorMsg = true;
    }
  }

  showMapConfirm(){
    this.mapOverlay = true;
  }

  callInitiateBasedOnCondition(email, loaderTextList) {
    if (this.appService.isUnconfirmedTicket) {
      this.appService.showLoaderWithText(loaderTextList);
      setTimeout(() => {
        const request = this.cartService.getPassengerRequestEntityUsingEmail(email);
        this.httpService.getData(request).subscribe(
          passengerResponse => {
            if (passengerResponse) {
              this.doInitiateReserveCall();
            } else if (passengerResponse.errors) {
              this.appService.hideLoaderWithText();
              const singleError = [];
              singleError.push(passengerResponse.errors);
              this.errorService.addError(singleError);
            }
          },
          error => {
            this.appService.hideLoaderWithText();
            this.errorService.addError(error);
          }
        );
      }, 1000);
    } else {
      this.doInitiateReserveCall();
    }
  }

  onActiveEmail() {
    this.showEmailErrorMsg = false;
    this.checkEmailState('focused');
  }

  onBlurEmail() {
    this.showEmailErrorMsg = true;
    this.checkEmailState('blur');
  }

  checkEmailState(state) {
    if (state === 'focused' || this.email.value) {
      this.emailTopSet = true;
    } else {
      this.emailTopSet = false;
    }
  }

  closeEmailOverlay() {
    this.updateEmailOverLay = false;
    this.emailForm.controls['email'].setValue('');
    this.showEmailErrorMsg = false;
    this.cartButton.emit(true);
    this.errorService.removeError();
  }

  get email() {
    return this.emailForm.get('email');
  }

  proceedToPayment(event) {
    this.mapOverlay = false;
    this.passengerInfo = this.buyWifiService.getPassengerResponse();
    if (this.sessionValue) {
      this.buyWifiService.setSessionValue(this.sessionValue);
      if (this.showEBforPointsBuy) {
        CartComponent.showPaymentConfirmationScreen = true;
        this.errorService.removeError();
      }
      else {
        if (this.appService.isUnconfirmedTicket) {
          const loaderTextList = { loaderHeaderText: APP_TRANSLATE.loaderText, loaderSubHeaderText: '' };
          this.appService.showLoaderWithText(loaderTextList);          
          setTimeout(() => {
            const request = this.cartService.getPassengerRequestEntityUsingEmail(this.buyWifiService.receiptEmailAddress);
            this.httpService.getData(request).subscribe(
              passengerResponse => {
                if (passengerResponse) {
                  this.doInitiateReserveCall();
                } else if (passengerResponse.errors) {
                  this.appService.hideLoaderWithText();
                  const singleError = [];
                  singleError.push(passengerResponse.errors);
                  this.errorService.addError(singleError);
                }
              },
              error => {
                this.appService.hideLoaderWithText();
                this.errorService.addError(error);
              }
            );
          }, 1000);
        } else {
          this.doInitiateReserveCall();
        }
      }
    } else {
      this.cartButtonEvent.emit();
    }
  }

  doInitiateReserveCall() {
    if (this.fullFillment) {
      this.appService.showLoaderWithText(this.loaderTextList);
      this.cartService.initiateReserveCall(this.sessionValue).subscribe(
        reserveCallResponse => {
          if (reserveCallResponse.status === 'RES') {
            this.buyWifiService.setReserveResponse(reserveCallResponse);
            this.router.navigate(['buywifi/payment']);
          } else if (reserveCallResponse.status === 'REF' || reserveCallResponse.status === 'FAILURE') {
            const errorCode = reserveCallResponse.notification[0].code;
            if (reserveCallResponse.notification && errorCode && errorCode.substring(0, 1) === '7') {
              const singleError = [];
              singleError.push({ 'errorCode': reserveCallResponse.notification[0].code });
              this.errorService.addError(singleError);
            } else {
              this.errorService.addError(this.buyWifiService.getDefaultError());
            }
          }
        }, error => {
          this.errorService.addError(this.buyWifiService.getDefaultError());
          this.appService.hideLoader();
          this.appService.hideLoaderWithText();
          this.cartService.closeOverlayWhenInitiateFailed();
        });
    } else {
      this.appService.hideLoaderWithText();
      this.router.navigate(['buywifi/payment']);
    }
  }

  get showPaymentConfirmationScreen() {
    return CartComponent.showPaymentConfirmationScreen;
  }

  checkReleaseCall() {
    const checkoutId = this.buyWifiService.getCheckOutId();
    if (checkoutId !== '') {
      this.appService.showLoaderWithText(this.loaderTextList);
      this.cartService.doReleaseCall(checkoutId).subscribe(
        checkoutCallResponse => {
          this.appService.hideLoaderWithText();
        });
    } else {
      this.appService.hideLoaderWithText();
    }
  }

  loadUpdateEmailOverLay(event) {
    this.errorService.removeError();
    this.updateEmailOverLay = true;
    event.preventDefault();
    this.accessibilityService.focus('.sasPaymentPayNowButton');
    this.accessibilityService.focus('#receipt-msg');
  }

  urlRedirectToHomepage(){
    LandingComponent.showActivateScreen = false;
    this.appService.scrollToTop();
    this.appService.addScrollBody();
    if (ONBOARD_CONSTANTS.ENABLE_DEVICE_TOKEN_STRIPPING) {
      this.router.navigate(['/onboard/home']);
    } else {
      this.router.navigate(['/onboard/home'], { queryParams: { 'deviceToken': sessionStorage.getItem('deviceToken') } });
    }
  }

  // Accessibility Methods
  focusUpdateEmailCloseButton(event) {
    event.preventDefault();
    this.accessibilityService.focus('#update-modal-close');
  }

  shiftTabFromEmailClose(event) {
    event.preventDefault();
    if (this.emailForm.invalid) {
      this.accessibilityService.focus('#update-email-input');
    } else {
      this.accessibilityService.focus('#update-email-connect');
    }
  }

  tabFromEmailInput(event) {
    if (this.emailForm.invalid) {
      this.accessibilityService.updateAttributeValue('#update-email-input', 'aria-invalid', 'true');
    } else {
      this.accessibilityService.updateAttributeValue('#update-email-input', 'aria-invalid', 'false');
    }
  }

  keytabFocus(event, id) {
    this.accessibilityService.focus(id);
    event.preventDefault();
  }

  keyshiftTabFocus(event, id) {
    if (event.shiftKey && event.key === 'Tab') {
      this.accessibilityService.focus(id);
      event.preventDefault();
    }
  }

  @HostListener('window:keydown', ['$event'])
  keyboardEents(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeEmailOverlay();
    }
  }

}
